import httpProvider from '../providers/http.js'

/**
 * Извлекает данные из axios-ответа.
 * @param {Object} response - axios response
 * @returns {Object} response.data или response целиком
 */
function extractData(response) {
  return response.data || response
}

export default {
  getPanels(cuid, params = {}) {
    const query = new URLSearchParams(params).toString()
    return httpProvider
      .get(`/contact-config/${cuid}/panels?${query}`)
      .then(extractData)
  },

  getPanel(cuid, panelId, organizationId) {
    return httpProvider
      .get(
        `/contact-config/${cuid}/panels/${panelId}?organization_id=${organizationId}`
      )
      .then(extractData)
  },

  createPanel(cuid, data) {
    return httpProvider
      .post(`/contact-config/${cuid}/panels`, data)
      .then(extractData)
  },

  updatePanel(cuid, panelId, data) {
    return httpProvider
      .put(`/contact-config/${cuid}/panels/${panelId}`, data)
      .then(extractData)
  },

  deletePanel(cuid, panelId, organizationId) {
    return httpProvider
      .delete(
        `/contact-config/${cuid}/panels/${panelId}?organization_id=${organizationId}`
      )
      .then(() => ({ success: true, panelId }))
  },

  deletePanels(cuid, panelIds, organizationId) {
    const uniquePanelIds = [...new Set(panelIds)]
    return Promise.all(
      uniquePanelIds.map(panelId =>
        this.deletePanel(cuid, panelId, organizationId)
      )
    )
  },

  /**
   * Генерация ссылки доступа для существующего устройства панели.
   * POST /api/contact-config/{cuid}/panels/{panel_id}/devices/{device_id}/generate-link
   */
  generatePanelAccessLink(cuid, panelId, deviceId, organizationId) {
    return httpProvider
      .post(
        `/contact-config/${cuid}/panels/${panelId}/devices/${deviceId}/generate-link`,
        { organization_id: organizationId }
      )
      .then(extractData)
  },

  /**
   * Генерация ссылки доступа без привязки к панели (для использования при создании).
   * POST /api/contact-config/device-access/generate-link
   */
  generateDeviceAccessLink() {
    return httpProvider
      .post('/contact-config/device-access/generate-link')
      .then(extractData)
  },

  getManufacturers() {
    return httpProvider.get('/panel-manufacturers').then(extractData)
  },

  getControlledDeviceTypes() {
    return httpProvider.get('/controlled-device-types').then(extractData)
  },
}
